/**
 * Reloads the current page. Isolated so tests can mock it, as `window.location.reload` cannot be
 * spied on in a real browser.
 */
export const reloadPage = (): void => {
  window.location.reload();
};
